import { api_configuration } from "../../../common";
import csr = api_configuration.types.client_state.alan_api;
import gui_definition_types = api_configuration.libraries.gui_definition_lib.types;
import messages = require("../../front/messages");
import add = require("./add");
import { createIdPathBuilderFromNode } from "../../navigation/createIdPathFromNode";
import createSubscriptionFromDuplicationMapping from "../../state 2 interface/createSubscriptionFromDuplicationMapping";
import initializeNewNodeFromSubscriptionResult from "../../state 2 interface/initializeNewNodeFromSubscriptionResult";
import { DatastoreProxy } from "../../interface/DatastoreProxy";
import { getGuiCollection } from "../../guiModel";
import { ignoreCollectionDefaults } from "../../state/ClientState";

export function entity(
	node: csr.Cnode,
	view: gui_definition_types.views.alan_api.Cviews__,
	window: gui_definition_types.settings.alan_api.Cwindows
): void {
	node.input.entity().switch({
		root: () => {
			messages.addMessage("warning", "Duplication not allowed", { body: "Can not duplicate the root." });
		},
		entry: (collection_entry) => {
			collection_entry.parent.properties.is_editable.switch({
				no: () => {
					messages.addMessage("warning", "Duplication not allowed", {
						body: "You do not have the sufficient rights to perform this operation.",
					});
				},
				yes: () => {
					getGuiCollection(collection_entry.parent.inferences.collection_type())?.properties.duplication_mapping.switch(
						{
							"from current context": function ($) {
								const mapping = $.properties.mapping;
								const collection = collection_entry.parent;
								ignoreCollectionDefaults.set(true);
								const new_node = add.entry(collection, view, window);
								const subscription = createSubscriptionFromDuplicationMapping(
									mapping,
									createIdPathBuilderFromNode(node).build()
								);
								DatastoreProxy.instance.subscribeOnce(subscription, function (subscription_result) {
									if (new_node.destroyed) {
										ignoreCollectionDefaults.set(false);
										return;
									}
									subscription_result.properties.context.switch({
										exists: function ($) {
											initializeNewNodeFromSubscriptionResult(new_node, mapping, $.properties.subscription_result_data);
										},
										"does not exist": undefined,
										"permission denied": () => {
											messages.addMessage(
												"warning",
												"You do not have the sufficient rights to perform this operation."
											);
										},
									});
									ignoreCollectionDefaults.set(false);
								});
							},
							none: function () {
								messages.addMessage("warning", "Cannot duplicate this item.");
							},
						}
					);
				},
			});
		},
	});
}
